<a
  class="btn-close"
  [routerLink]="null"
  queryParamsHandling="preserve"
  (click)="onClick()"
  [matomoClickCategory]="MATOMO_EVENT_CATEGORY_HEADER"
  matomoClickAction="Select_CloseButton">
  <yat-icon id="623bd438-955e-4516-aae1-46cab7257737" name="cross"></yat-icon>
</a>
